import * as React from 'react';
import { View, Text, Platform } from 'react-native';
import { api, url, isDev } from '../../constants/DevProd';
import Constants from 'expo-constants';
import * as Linking from 'expo-linking';
import { Storage } from '../../components';
import * as Device from 'expo-device';

export default function TestScreen() {

  const iframe = () => {
    // const rtJWT = await Storage.getItem('rtJWT');
    return (
      <iframe
        width='300'
        height='300'
        src={`https://dev.renovationtrust.com/test/chad/test1.php`}
        frameborder='0'
      ></iframe>
    )
  }

  const embed = () => {
    return (
      <embed
        src="https://dev.renovationtrust.com/test/chad/forester.pdf"
        width='300'
        height='300'
        type="application/pdf"
        frameborder='0'
      ></embed>
    )
  }

  const object = () => {
    return (
      <object data="https://dev.renovationtrust.com/test/chad/forester.pdf" type="application/pdf"
        width="300" height="300">
        <p>You don't have a PDF plugin, but you can
          <a href="https://dev.renovationtrust.com/test/chad/forester.pdf">download the PDF file.
          </a>
        </p>
      </object>
    )
  }

  return (
    <View style={{ padding: 10, }}>
      <Text>api.base: {api.base}</Text>
      <Text>url.base: {url.base}</Text>
      <Text>isDev: {isDev ? 'true' : 'false'}</Text>
      {/* <Text>Constants.manifest.name: {Constants.manifest.name}</Text> */}
      <Text>Constants.appOwnership: {Constants.appOwnership}</Text>
      <Text>Constants.deviceName: {Constants.deviceName}</Text>
      <Text>Constants.expoVersion: {Constants.expoVersion}</Text>
      <Text>Device.isDevice: {Device.isDevice ? 'true' : 'false'}</Text>
      {/* <Text>Constants.platform: {JSON.stringify(Constants.platform)}</Text> */}
      {/* <Text>Platform: {JSON.stringify(Platform)}</Text> */}
      <Text>__DEV__: {__DEV__ ? 'true' : 'false'}</Text>
      <Text>process.env.APP_ENV: {process.env.APP_ENV}</Text>
      <Text>process.env: {JSON.stringify(process.env)}</Text>
      <Text>Linking.createURL('/'): {Linking.createURL('/')}</Text>
      {/* {iframe()}
      {embed()}
      {object()} */}
    </View>

  )
}

// export default function nativeDatePickerOnWeb() {
//   const [date, setDate] = React.useState('');

//   const onChange = (event) => {
//     console.log('onChange: ', event.target.value);
//     setDate(event.target.value);
//   }

//   const dateInput = React.createElement('input', {
//     type: 'date',
//     value: date,
//     onChange: onChange,
//     style: { padding: 10, borderColor: 'blue', borderWidth: 1, borderRadius: 10 }
//   })

//   return (
//     <View style={{ padding: 10, }}>
//       {dateInput}
//       <Text>{date}</Text>
//     </View>
    
//   )
// }

// React native paper dates
// import * as React from 'react';
// import { Text } from 'react-native';
// import { Button } from 'react-native-paper';
// import { DatePickerModal } from 'react-native-paper-dates';
// import { Portal } from 'react-native-paper';

// export default function ReadMeExampleSingle() {
//   const [date, setDate] = React.useState(null);
//   const [open, setOpen] = React.useState(false);

//   React.useEffect(() => {
//     getTest();
//   }, [])

//   const onDismissSingle = React.useCallback(() => {
//     setOpen(false);
//   }, [setOpen]);

//   const onConfirmSingle = React.useCallback(
//     (params) => {
//       setOpen(false);
//       setDate(params.date);
//     },
//     [setOpen, setDate]
//   );

//   return (
//     <>
//       <Button onPress={() => setOpen(true)} uppercase={false} mode="outlined">
//         Pick single date
//       </Button>
//       <Portal>
//         <DatePickerModal
//           // locale={'en'} optional, default: automatic
//           mode="single"
//           visible={open}
//           onDismiss={onDismissSingle}
//           date={date}
//           onConfirm={onConfirmSingle}
//         // validRange={{
//         //   startDate: new Date(2021, 1, 2),  // optional
//         //   endDate: new Date(), // optional
//         // }}
//         // onChange={} // same props as onConfirm but triggered without confirmed by user
//         // saveLabel="Save" // optional
//         // label="Select date" // optional
//         // animationType="slide" // optional, default is 'slide' on ios/android and 'none' on web
//         />
//       </Portal>
//       <Text>{open ? 'Open' : 'Closed'}</Text>
//     </>
//   );
// }


// import React from 'react';
// import { View, ScrollView, Text, StyleSheet, Platform, SafeAreaView, Modal, Dimensions } from 'react-native';
// import CS from '../../constants/Styles';
// import { useSafeAreaInsets } from 'react-native-safe-area-context';
// import { Modal as PModal, Portal, Button, Provider } from 'react-native-paper';

// const Resources = () => {
//   const [visible, setVisible] = React.useState(false);
//   const [pvisible, setpVisible] = React.useState(false);

//   const insets = useSafeAreaInsets();

//   const openModal = () => {
//     setVisible(true);
//   }
//   const modal = () => {
//     if (Platform.OS === 'web' && !visible) {
//       return null;
//     }
//     return (
//       <Modal
//         visible={visible}
//         style={StyleSheet.absoluteFill}
//         transparent={true}
//         style={Platform.OS === 'web' && CS.webModal}
//       >
//         <View style={{ flex: 1, backgroundColor: 'pink', alignItems: 'center', justifyContent: 'center' }}>
//           <Text style={[CS.smallText, CS.lightText]} onPress={() => { setVisible(false) }}>Modal Test</Text>
//         </View>
//       </Modal>
//     )
//   }

//   const openPaperModal = () => setpVisible(true);
//   const hidePaperModal = () => setpVisible(false);
//   const pmodal = () => {
//     // if (Platform.OS === 'web' && !pvisible) {
//     //   return null;
//     // }
//     return (
//       <Portal>
//         <PModal visible={pvisible} onDismiss={hidePaperModal} style={[CS.flex, { borderWidth: 0 }]}>
//           <SafeAreaView style={[CS.safe, { width: Dimensions.get('window').width, height: Dimensions.get('window').height, backgroundColor: 'purple', padding: 20, justifyContent: 'center', alignItems: 'center', borderWidth: 0, }]}>
//             <Text style={CS.centerText}>Paper Modal</Text>
//             <Button mode='contained' onPress={() => setpVisible(false)} style={styles.button}>Close</Button>
//           </SafeAreaView>
//         </PModal>
//       </Portal>
//     )
//   }

//   return (
//     <SafeAreaView style={CS.safe}>
//       <View style={CS.innerContainer}>
//         <Button mode='contained' onPress={openModal} style={styles.button}>Open Modal</Button>
//         <Button mode='contained' onPress={openPaperModal} style={styles.button}>Open Paper Modal</Button>
//         {modal()}
//         {pmodal()}
//       </View>
//     </SafeAreaView>
//   )
//   return (
//     <View style={[CS.safe, , { paddingBottom: insets.bottom }]}>
//       <ScrollView style={styles.container} >
//         <Text style={styles.input}>Default Text, no size, no style</Text>
//         <Text style={[styles.input, { fontSize: 18 }]}>fontSize 18 - smallText</Text>
//         <Text style={[styles.input, { fontSize: 20 }]}>fontSize 20</Text>
//         <Text style={[styles.input, { fontSize: 30 }]}>fontSize 30</Text>
//         <Text style={[styles.input, { fontSize: 40 }]}>fontSize 40</Text>
//         <Text style={[styles.input, { fontSize: 50 }]}>fontSize 50</Text>
//         <Text style={[styles.input, { fontSize: 60 }]}>fontSize 60</Text>
//         <Text style={[styles.input, { fontWeight: 'bold' }]}>fontWeight bold</Text>
//         <Text style={[styles.input, { fontWeight: '100' }]}>fontWeight 100</Text>
//         <Text style={[styles.input, { fontWeight: '200' }]}>fontWeight 200</Text>
//         <Text style={[styles.input, { fontWeight: '300' }]}>fontWeight 300</Text>
//         <Text style={[styles.input, { fontWeight: '400' }]}>fontWeight 400</Text>
//         <Text style={[styles.input, { fontWeight: '500' }]}>fontWeight 500</Text>
//         <Text style={[styles.input, { fontWeight: '600' }]}>fontWeight 600</Text>
//         <Text style={[styles.input, { fontWeight: '700' }]}>fontWeight 700</Text>
//         <Text style={[styles.input, { fontWeight: '800' }]}>fontWeight 800</Text>
//         <Text style={[styles.input, { fontWeight: '900' }]}>fontWeight 900</Text>
//         <Text style={[CS.miniText, styles.input]}>miniText</Text>
//         <Text style={[CS.smallText, styles.input]}>smallText</Text>
//         <Text style={[CS.mediumText, styles.input]}>mediumText</Text>
//         <Text style={[CS.largeText, styles.input]}>largeText</Text>
//         <Text style={[CS.smallTitle, styles.input]}>smallTitle</Text>
//         <Text style={[CS.mediumTitle, styles.input]}>mediumTitle</Text>
//         <Text style={[CS.largeTitle, styles.input]}>largeTitle</Text>
//         <Text style={[styles.input, CS.lightWeightText]}>lightWeightText</Text>
//         <Text style={[styles.input, CS.mediumWeightText]}>mediumWeightText</Text>
//       </ScrollView>
//     </View>
//   )

// }

// const styles = StyleSheet.create({
//   container: {
//     flex: 1,
//     width: '100%',
//     padding: 10,
//   },
//   input: {
//     borderWidth: 1,
//     borderColor: 'white',
//     marginVertical: 0,
//     marginBottom: 10,
//     color: 'white'
//   },
//   button: {
//     marginVertical: 10,
//   }
// })

// export default Resources;